import { FC } from 'react';
import { CatListItem } from '@blocks-react/components/ListItem';
import { RequestServiceDateProps } from '../../types';
import { CatIconSuccessFilled } from '@blocks-react/components/Icons/SuccessFilled';
import styles from '../RequestServiceCalendar.module.scss';
import clx from 'classnames';
import { CatHeading } from '@blocks-react/components/Heading';
import { CustomStyledLabel } from '../../custom-styled-label/CustomStyledLabel';

type dateItemProps = {
  dateItem: RequestServiceDateProps;
  customDateError: string;
  onClickHandler: (date: RequestServiceDateProps) => void;
  selectedDates: RequestServiceDateProps[];
  classname?: string;
  selectedClassname?: string;
};
export const CalendarCarouselItem: FC<dateItemProps> = ({
  dateItem,
  customDateError,
  onClickHandler,
  selectedDates = [],
  classname,
  selectedClassname
}) => {
  const isSelected = selectedDates.some(
    (selectedDate) => selectedDate.formattedDate === dateItem.formattedDate
  );
  return (
    <CatListItem
      className={clx(
        styles['calendar-container--carousel-item'],
        'me-1 me-md-0 position-relative'
      )}
      onBlSelect={() => onClickHandler(dateItem)}
    >
      <div
        className={clx(
          'ms-0 ms-md-2 px-3 d-flex align-items-center flex-column justify-content-center position-relative',
          styles['calendar-container--date-cell'],
          {
            [`${selectedClassname} ${styles['calendar-container--selected']}`]:
              isSelected,
            [`${classname}`]: !isSelected && !customDateError,
            [styles['calendar-container--error']]:
              customDateError && !isSelected
          }
        )}
      >
        {isSelected && (
          <div
            className={`bg-light ${styles['calendar-container--selected-icon-container']}`}
            data-testid="selected-icon"
          >
            <CatIconSuccessFilled />
          </div>
        )}

        <CatHeading variant="label-sm" className="mb-1 text-uppercase">
          <CustomStyledLabel>{dateItem.day}</CustomStyledLabel>
        </CatHeading>
        <CatHeading variant="body-sm">
          <CustomStyledLabel>{dateItem.date}</CustomStyledLabel>
        </CatHeading>
      </div>
    </CatListItem>
  );
};
